import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioManualValueResponseDTO,
	type ClientPortfolioManualValueSaveRequestDTO,
	putPortfolioIdManualValueV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type ManualValueVariables = {
	portfolioId: number;
	request: ClientPortfolioManualValueSaveRequestDTO;
};

export const usePutPortfolioManualValueMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPortfolioManualValueResponseDTO,
		Error,
		ManualValueVariables
	>({
		mutationFn: processResponse(({ portfolioId, request }) =>
			putPortfolioIdManualValueV2(request, portfolioId),
		),
		onSuccess: (_, { portfolioId }) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.reporting(portfolioId),
			});
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioDetail(portfolioId),
			});
			queryClient.invalidateQueries({ queryKey: GoalsKeys.all });
		},
	});
};
